import { type FC } from 'react';
import {
  MapPin
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconMapPinProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconMapPin: FC<UiIconMapPinProps> = (props) => {
  return (
    <UiIcon
      IconComponent={MapPin}
      {...props}
    />
  );
};
